var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04952 19.5102C3.07288 19.5102 0.661158 17.0909 0.673189 14.1109C0.685766 11.2098 3.0335 8.82048 5.93467 8.75923C6.3492 8.75048 6.75335 8.78931 7.14217 8.86915C7.81647 5.68415 10.6416 3.29321 14.0279 3.29321C17.1155 3.29321 19.7329 5.28438 20.6817 8.04993C20.9688 8.00618 21.2603 7.9761 21.5594 7.9761C24.7958 7.9761 27.4094 10.6416 27.3246 13.8971C27.2431 17.0318 24.634 19.5102 21.4982 19.5102H6.04952Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1953 20.2507C18.9503 20.2507 18.7496 20.4514 18.7496 20.6964V24.261C18.7496 24.506 18.9503 24.7067 19.1953 24.7067C19.4403 24.7067 19.641 24.506 19.641 24.261V20.6964C19.641 20.4514 19.4403 20.2507 19.1953 20.2507ZM14 20.2507C13.755 20.2507 13.5543 20.4514 13.5543 20.6964V24.261C13.5543 24.506 13.755 24.7067 14 24.7067C14.245 24.7067 14.4457 24.506 14.4457 24.261V20.6964C14.4457 20.4514 14.245 20.2507 14 20.2507ZM8.80466 20.2507C8.55966 20.2507 8.35896 20.4514 8.35896 20.6964V24.261C8.35896 24.506 8.55966 24.7067 8.80466 24.7067C9.04966 24.7067 9.25037 24.506 9.25037 24.261V20.6964C9.25037 20.4514 9.04966 20.2507 8.80466 20.2507Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBtn);
export default __webpack_public_path__ + "static/media/iconBtn.1eac8a583bccd2e1556f41f4c1c1a02b.svg";
export { ForwardRef as ReactComponent };